import React, {Component} from 'react';
import Calculator from './Calculator';

class App extends Component {

    constructor(props) {
        super(props);
    }

    initConfig() {
        if (this.props.calculator === 'solidAcre') {
            return App.solidAcre();
        }
        if (this.props.calculator === 'solidHectare') {
            return App.solidHectare();
        }
        return this.props.calculator === 'liquidAcre' ? App.liquidAcre() : App.liquidHectare();
    }

    static liquidHectare() {
        return [
            // {fieldname: fieldlabel}
            {
                name: 'rof',
                type: 'number',
                default: 0,
                label: 'Liều lượng phân bón (Lít / hecta):'
            },
            {
                name: 'fgddkgh',
                type: 'dropdown',
                source: App.getDataSource('fgddkgh'),
                default: 1.279,
                onchange: function(value) {
                    let key;
                    for(key in value) {
                        this.updateValues({ppgofdd: value[key], fgddkgh: value[key]});

                        if (0 == value[key]) {
                            // Show up the manual input.
                            this.toggleHiddenState('fgm', false);
                            this.setTypeState('ppgofdd', 'number');
                        } else {
                            this.toggleHiddenState('fgm', true);
                            this.setTypeState('ppgofdd', 'label');
                        }
                    }
                },
                label: 'Hàm lượng dưỡng chất trong phân bón:'
            },
            {
                name: 'fgm',
                type: 'text',
                default: '',
                hidden: true,
                label: 'Hàm lượng dưỡng chất trong phân bón (Nhập tay):'
            },
            {
                name: 'ppgofdd',
                type: 'label',
                default: 1.279,
                label: 'Số ki-lô-gram dùng cho mỗi lít phân bón:'
            },
            {
                name: 'ppgof',
                type: 'label',
                default: 0.002,
                format: false,
                hidden: true,
                label: 'BiOWiSH® Crop Liquid ratio to amount of Fertilizer (0.2%):'
            },
            {
                name: 'pbpa',
                type: 'label',
                default: 0,
                label: 'Số ki-lô-gram BiOWiSH® dùng cho mỗi hecta:',
                formula: function() {

                    let a   = this.nextState.values_ppgofdd;
                    let b   = this.nextState.values_rof;
                    let c   = this.nextState.values_ppgof;

                    //console.log(a);

                    if(a <= 0 || b <= 0)  // So nothing if there is no argument input
                        return 0;

                    return a*b*c;
                }
            },
            {
                name: 'gobpa',
                type: 'label',
                default: 0,
                formula: function() {
                    let a   = this.nextState.values_ppgofdd;
                    let b   = this.nextState.values_pbpa;

                    if(0 >= a && 0 >= b)  // So nothing if there is no argument input
                        return 0;

                    return b;
                },
                label: 'Số lít BiOWiSH® dùng cho mỗi hecta:'
            },
            {
                name: 'currency',
                type: 'dropdown',
                source: App.getDataSource('currency'),
                //default: '£',
                onchange: function(value) {
                    this.updateCurrency(value);
                },
                label: 'Lựa chọn đơn vị tiền tệ:'
            },
            {
                name: 'dsp',
                type: 'number',
                default: 0,
                format: 'currency',
                label: 'Giá bán cho nhà phân phối (BiOWiSH® / lít):'
            },
            {
                name: 'bcpa',
                type: 'label',
                default: 0,
                format: 'currency',
                formula: function() {
                    let a   = this.nextState.values_gobpa;
                    let b   = this.nextState.values_dsp;

                    if(0 >= a || 0 >= b)  // So nothing if there is no argument input
                        return 0;

                    return a*b;
                },
                label: 'Giá BiOWiSH® cho mỗi hecta:'
            }
        ];
    }

    static liquidAcre() {
        return [
            // {fieldname: fieldlabel}
            {
                name: 'rof',
                type: 'number',
                default: 0,
                label: 'Liều lượng phân bón (ga-lông / mẫu Anh):'
            },
            {
                name: 'fgdd',
                type: 'dropdown',
                source: App.getDataSource('fgdd'),
                default: 10.67,
                onchange: function(value) {
                    let key;
                    for(key in value) {
                        this.updateValues({ppgofdd: value[key], fgdd: value[key]});

                        if (0 == value[key]) {
                            // Show up the manual input.
                            this.toggleHiddenState('fgm', false);
                            this.setTypeState('ppgofdd', 'number');
                        } else {
                            this.toggleHiddenState('fgm', true);
                            this.setTypeState('ppgofdd', 'label');
                        }
                    }
                },
                label: 'Hàm lượng dưỡng chất trong phân bón:'
            },
            {
                name: 'fgm',
                type: 'text',
                default: 0,
                hidden: true,
                label: 'Hàm lượng dưỡng chất trong phân bón (Nhập tay):'
            },
            {
                name: 'ppgofdd',
                type: 'label',
                default: 10.67,
                label: 'Số cân Anh dùng cho mỗi ga-lông phân bón:'
            },
            {
                name: 'ppgof',
                type: 'label',
                default: 0.002,
                format: false,
                hidden: true,
                label: 'Số cân Anh dùng cho mỗi ga-lông phân bón:'
            },
            {
                name: 'pbpa',
                type: 'label',
                default: 0,
                label: 'Số cân Anh BiOWiSH® dùng cho mỗi mẫu Anh:',
                formula: function() {

                    let a   = this.nextState.values_ppgofdd;
                    let b   = this.nextState.values_rof;
                    let c   = this.nextState.values_ppgof;

                    //console.log(a);

                    if(a <= 0 || b <= 0)  // So nothing if there is no argument input
                        return 0;

                    return a*b*c;
                }
            },
            {
                name: 'gobpa',
                type: 'label',
                default: 0,
                formula: function() {
                    let a   = this.nextState.values_ppgofdd;
                    let b   = this.nextState.values_pbpa;

                    if(0 >= a && 0 >= b)  // So nothing if there is no argument input
                        return 0;

                    return b/2.2/3.78541;
                },
                label: 'Số ga-lông BiOWiSH® dùng cho mỗi mẫu Anh:'
            },
            {
                name: 'currency',
                type: 'dropdown',
                source: App.getDataSource('currency'),
                //default: '$',
                onchange: function(value) {
                    this.updateCurrency(value);
                },
                label: 'Lựa chọn đơn vị tiền tệ:'
            },
            {
                name: 'dsp',
                type: 'number',
                default: 0,
                format: 'currency',
                label: 'Giá bán dành cho Nhà phân phối (BiOWiSH® / ga-lông):'
            },
            {
                name: 'bcpa',
                type: 'label',
                default: 0,
                format: 'currency',
                formula: function() {
                    let a   = this.nextState.values_gobpa;
                    let b   = this.nextState.values_dsp;

                    if(0 >= a || 0 >= b)  // So nothing if there is no argument input
                        return 0;

                    return a*b;
                },
                label: 'Giá BiOWiSH® cho mỗi mẫu Anh:'
            }
        ];
    }

    static getDataSource(field) {
        switch(field) {
            case 'fgdd':
                return {
                    '28-0-0':               10.67,
                    '32-0-0':               11.06,
                    '10-34-0':              11.65,
                    '12-0-0-26S':           11.04,
                    '10-0-0-10Zn':          10.4,
                    '7-21-7':               11.2,
                    '4-10-10':              10.3,
                    '8-21-4-3S-0.5Zn':      11.30000001,
                    '9-18-4-6S-0.5Zn':      11.30000002,
                    '9-20-2-7S-0.5Zn':      11.4,
                    '18-13-0-7S':           11.30000003,
                    '10-30-0-3S':           11.7,
                    'Hydra-Hume':           8.66,
                    'Khác':               0,
                };
            case 'fgddkgh':
                return {
                    '28-0-0':               1.279,
                    '32-0-0':               1.325,
                    '10-34-0':              1.396,
                    '12-0-0-26S':           1.322882352,
                    '10-0-0-10Zn':          1.24619352,
                    '7-21-7':               1.34205456,
                    '4-10-10':              1.23421089,
                    '8-21-4-3S-0.5Zn':      1.354037190001,
                    '9-18-4-6S-0.5Zn':      1.354037190002,
                    '9-20-2-7S-0.5Zn':      1.36601982,
                    '18-13-0-7S':           1.354037190003,
                    '10-30-0-3S':           1.40196771,
                    'Khác':               0,
                };
            case 'currency':
                return {
                    'United States':        '$',
                    'China':                '¥',
                    'India':                '₹',
                    'Thailand':             '฿',
                    'Australia':            '$',
                    'Indonesia':            'Rp',
                    'Argentina':            '$',
                    'Ecuador':              '$',
                    'Romania':              'lei',
                    'South Korea':          '₩',
                    'Colombia':             '$',
                    'Costa Rica':           '₡',
                    'Egypt':                'E£',
                    'Guatemala':            'Q',
                    'Honduras':             'L',
                    'Malaysia':             'RM',
                    'New Zealand':          '$',
                    'Nicaragua':            'C$',
                    'Nigeria':              '₦',
                    'Pakistan':             'Rs',
                    'Peru':                 'S/.',
                    'Philippines':          '₱',
                    'Qatar':                'QAR',
                    'Saudi Arabia':         'SR',
                    'Sri Lanka':            'Rs',
                    'Turkey':               '₺',
                    'United Kingdom':       '£',
                    'Vietnam':              '₫',
                };
            default:
                return [];
        }
    }

    static solidAcre() {
        return [
            // {fieldname: fieldlabel}
            {
                name: 'rof',
                type: 'number',
                default: 0,
                label: 'Liều lượng phân bón (cân Anh / mẫu Anh):'
            },
            {
                name: 'robppf',
                type: 'label',
                default: 0.002,
                hidden: true,
                format: false,
                label: 'Pounds per Gallon of Fertilizer'
            },
            {
                name: 'pbpa',
                type: 'label',
                default: 0,
                label: 'Số cân Anh BiOWiSH® dùng cho mỗi mẫu Anh:',
                formula: function() {

                    let a   = this.nextState.values_rof;
                    let b   = this.nextState.values_robppf;

                    if(a <= 0)  // So nothing if there is no argument input
                        return 0;

                    return a*b;
                }
            },
            {
                name: 'gobpa',
                type: 'label',
                default: 0,
                formula: function() {
                    let a   = this.nextState.values_pbpa;

                    if(0 >= a)  // So nothing if there is no argument input
                        return 0;

                    return a/2.2/3.78541;
                },
                label: 'Số ga-lông BiOWiSH® dùng cho mỗi mẫu Anh:'
            },
            {
                name: 'currency',
                type: 'dropdown',
                source: App.getDataSource('currency'),
                //default: '£',
                onchange: function(value) {
                    this.updateCurrency(value);
                },
                label: 'Lựa chọn đơn vị tiền tệ:'
            },
            {
                name: 'dsp',
                type: 'number',
                default: 0,
                label: 'Giá bán dành cho Nhà phân phối (BiOWiSH® / ga-lông):'
            },
            {
                name: 'bcpa',
                type: 'label',
                default: 0,
                format: 'currency',
                formula: function() {
                    let a   = this.nextState.values_dsp;
                    let b   = this.nextState.values_gobpa;

                    if(0 >= a || 0 >= b)  // So nothing if there is no argument input
                        return 0;

                    return a*b;
                },
                label: 'Giá BiOWiSH® cho mỗi mẫu Anh:'
            }
        ];
    }

    static solidHectare() {
        return [
            // {fieldname: fieldlabel}
            {
                name: 'rof',
                type: 'number',
                default: 0,
                label: 'Liều lượng phân bón (ki-lô-gram / hecta):'
            },
            {
                name: 'robpkf',
                type: 'label',
                default: 0.002,
                hidden: true,
                format: false,
                label: 'Rate of BiOWiSH® per Kg Fertilizer'
            },
            {
                name: 'kbph',
                type: 'label',
                default: 0,
                label: 'Số ki-lô-gram BiOWiSH® dùng cho mỗi hecta:',
                formula: function() {

                    let a   = this.nextState.values_rof;
                    let b   = this.nextState.values_robpkf;

                    if(a <= 0)  // So nothing if there is no argument input
                        return 0;

                    return a*b;
                }
            },
            {
                name: 'lobph',
                type: 'label',
                default: 0,
                formula: function() {
                    let a   = this.nextState.values_kbph;

                    if(0 >= a)  // So nothing if there is no argument input
                        return 0;

                    return a;
                },
                label: 'Số lít BiOWiSH® dùng cho mỗi hecta:'
            },
            {
                name: 'currency',
                type: 'dropdown',
                source: App.getDataSource('currency'),
                //default: '£',
                onchange: function(value) {
                    this.updateCurrency(value);
                },
                label: 'Lựa chọn đơn vị tiền tệ:'
            },
            {
                name: 'dsp',
                type: 'number',
                default: 0,
                label: 'Giá bán dành cho Nhà phân phối (BiOWiSH® / lít):'
            },
            {
                name: 'bcph',
                type: 'label',
                default: 0,
                format: 'currency',
                formula: function() {
                    let a   = this.nextState.values_dsp;
                    let b   = this.nextState.values_lobph;

                    if(0 >= a || 0 >= b)  // So nothing if there is no argument input
                        return 0;

                    return a*b;
                },
                label: 'Giá BiOWiSH® cho mỗi hecta:'
            }
        ];
    }


    render() {
        return (
            <div className="App">
                <Calculator id={this.props.calculator} config={this.initConfig()}/>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js